<template>
  <a :href="href" target="_blank" rel='nofollow noopener'>
    <IconBase viewBox="0 0 32 32">
      <pdfIco></pdfIco>
    </IconBase>
    <span>{{title}}</span>
  </a>
</template>

<script>
  export default {
    name: "pdfLink",
    props: {
      href: {
        type: String,
        default: '#'
      },
      title: {
        type: String,
        default: 'empty',
      },
    },
    components: {
      IconBase: () => import('@/components/svg/IconBase'),
      pdfIco: () => import('@/components/svg/pdf'),
    }
  }
</script>

<style scoped>

</style>
